import React, { Component } from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';

import AccountCircle from '@mui/icons-material/AccountCircle';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { signout } from "../../auth";
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import ViewInArRoundedIcon from '@mui/icons-material/ViewInArRounded';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import CorporateFareRoundedIcon from '@mui/icons-material/CorporateFareRounded';
import AddchartRoundedIcon from '@mui/icons-material/AddchartRounded';
import CameraRoundedIcon from '@mui/icons-material/CameraRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import StoreRoundedIcon from '@mui/icons-material/StoreRounded';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import TravelExploreRoundedIcon from '@mui/icons-material/TravelExploreRounded';
import FormatLineSpacingRoundedIcon from '@mui/icons-material/FormatLineSpacingRounded';
import DisplaySettingsRoundedIcon from '@mui/icons-material/DisplaySettingsRounded';
import SettingsAccessibilityRoundedIcon from '@mui/icons-material/SettingsAccessibilityRounded';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import MediationRoundedIcon from '@mui/icons-material/MediationRounded';

// All views available
import ProjectsView from '../../views/projects';
import DashboardView from '../../views/dashboard';
import ArcGISView from '../../views/arcGIS';
import ArcGIS3dView from '../../views/arcGIS3d';
import arcGISEnviro from '../../views/ArcGISEnviro';
import ArcGISIOTView from '../../views/ArcGISIOT';
import DesignsView from '../../views/designs';
import ConstructionView from '../../views/construction';
import OperationsView from '../../views/operations';
import AnalyticsView from '../../views/analytics';
import VisualizationView from '../../views/visualization';
import ManagementView from '../../views/management';
import AssetStore from '../../views/assetstore';
import BIMView from '../../views/bim';
import GlobalRegView from '../../views/globalreg';
import UsersView from '../../views/users';
import ConfiguratorView from '../../views/configurators';
import NotificationView from '../../views/notifications';
import TranslationsView from '../../views/translations';
import ProfileView from '../../views/profile';
import VideoFeedView from '../../views/videoanalysis';

import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation';
import OnDeviceTrainingIcon from '@mui/icons-material/OnDeviceTraining';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import ArcGISEnviroView from '../../views/ArcGISEnviro';

function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            Copyright {new Date().getFullYear()} {'© '}
            <Link color="inherit" href="https://www.spatialbiz.com/">
                Spatial Business Systems, Inc.
            </Link>
        </Typography>
    );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(9),
                },
            }),
        },
    }),
);

const mdTheme = createTheme();


class DashboardContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            history: [],
            open: false,
            arcGISOpen: false,
            dataOpen: false,
            menuId: 'primary-search-account-menu',
            anchorEl: null,
            currentPage: '',
            selectedIndex: localStorage.getItem('viewIndex'),
            viewName: this.props.match.params.view
        }
    }




    componentWillMount() {
      
            localStorage.setItem('jwt', '');
    
        if (!localStorage.getItem('drawerStat')) {
            this.setState({ open: true })
        } else {
            this.setState({ open: (localStorage.getItem('drawerStat').toLowerCase() === 'true') })
        }
        if (!localStorage.getItem('viewIndex')) { localStorage.setItem('viewIndex', '0') }

        this.setState({
            selectedIndex: localStorage.getItem('viewIndex')
        })
    };

    handleListItemClick = (event, index, name) => {
        localStorage.setItem('viewIndex', index)
        this.setState({
            selectedIndex: index,
            currentPage: name,
            viewName: name
        })
        // 'turns out I didn't need this at all
        // window.location.href = "/dashboard/" + name
    };

    toggleDrawer = () => {
        this.setState({ open: !this.state.open })
        localStorage.setItem('drawerStat', !this.state.open)
    };

    handleChange = name => event => {
        //if (name == "question1") 
        //event.target.value        
    }

    handleMenu = (event) => {
        this.setState({
            anchorEl: event.currentTarget
        })
    };

    handleClose = () => {
        this.setState({ anchorEl: null })
    };


    handleClick = () => {
        this.setState({ open: !this.state.open })
    };

    handleListArcGISClick = () => {
        this.setState({ arcGISOpen: !this.state.arcGISOpen })
    };

    handleDataClick = () => {
        this.setState({ dataOpen: !this.state.dataOpen })
    };

    getIcon(viewName) {

        switch (viewName) {
            case 'main':
                return <DashboardIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'arcGIS':
                return <AddLocationAltIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'arcGIS3d':
                return <ThreeDRotationIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'arcGISIOT':
                return <OnDeviceTrainingIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'arcGISEnviro':
                return <ThermostatIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'projects':
                return <ContentCopyRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'arcGISIOT':
                return <AddchartRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'designs':
                return <ViewInArRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'construction':
                return <EngineeringRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'operations':
                return <CorporateFareRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'analytics':
                return <AddchartRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'visualization':
                return <CameraRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'management':
                return <ManageAccountsRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'assetstore':
                return <StoreRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'users':
                return <SettingsAccessibilityRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'configurators':
                return <DisplaySettingsRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'notifications':
                return <NotificationsActiveRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            case 'translations':
                return <MediationRoundedIcon sx={{ mr: 0.5 }} fontSize='inherit' />;
            default:
                return null
        };
    };

    getDescriptionForHelp(viewName) {

        switch (viewName) {
            case 'main':
                return <Typography variant="body1" gutterBottom>Main Dashboards</Typography>;
            case 'arcGIS':
                return <Typography variant="body1" gutterBottom>arcGIS Location Example calling Autodesk Forge</Typography>;
            case 'arcGIS3d':
                return <Typography variant="body1" gutterBottom>arcGIS 3D scene example locating models </Typography>;
            case 'arcGISIOT':
                return <Typography variant="body1" gutterBottom>arcGIS Webscene example with IOT data</Typography>;
            case 'arcGISEnviro':
                return <Typography variant="body1" gutterBottom>arcGIS example of IOT Environment</Typography>;
            case 'projects':
                return <Typography variant="body1" gutterBottom>Active Projects</Typography>;            
            case 'designs':
                return <Typography variant="body1" gutterBottom>Build Digital Twin information</Typography>;
            case 'construction':
                return <Typography variant="body1" gutterBottom>Example work schedule and tasks</Typography>;
            case 'operations':
                return <Typography variant="body1" gutterBottom>Operations example highlighting real-time messages</Typography>;
            case 'analytics':
                return <Typography variant="body1" gutterBottom>Equipment Analysis and Predicitve Analytics</Typography>;
            case 'visualization':
                return <Typography variant="body1" gutterBottom>Visualizatin Packages</Typography>;
            case 'management':
                return <Typography variant="body1" gutterBottom>Example storage management features</Typography>;
            case 'assetstore':
                return <Typography variant="body1" gutterBottom>The Future Abraxas App Store</Typography>;
            case 'users':
                return <Typography variant="body1" gutterBottom>Not published yet</Typography>;
            case 'configurators':
                return <Typography variant="body1" gutterBottom>Not published yet</Typography>;
            case 'notifications':
                return <Typography variant="body1" gutterBottom>Not published yet</Typography>;
            case 'translations':
                return <Typography variant="body1" gutterBottom>Not published yet</Typography>;
            default:
                return null
        };
    };


    secondaryLink(viewName) {

        return (
            <Link
                underline="hover"
                sx={{ display: 'flex', alignItems: 'center' }}
                color="inherit"
                href={viewName}
            >
                {this.getIcon(viewName)}
                {viewName}
            </Link>
        )
    }


    getTheProperView(viewName) {
        switch (viewName) {
            case 'main':
                return <DashboardView />
            case 'arcGIS':
                return <ArcGISView />
            case 'arcGIS3d':
                return <ArcGIS3dView />
            case 'arcGISIOT':
                return <ArcGISIOTView />
            case 'arcGISEnviro':
                return <ArcGISEnviroView />
            case 'projects':
                return <ProjectsView />
            case 'designs':
                return <DesignsView />
            case 'construction':
                return <ConstructionView />
            case 'operations':
                return <OperationsView />
            case 'analytics':
                return <AnalyticsView />
            case 'visualization':
                return <VisualizationView />
            case 'management':
                return <ManagementView />
            case 'assetstore':
                return <AssetStore />
            case 'bim':
                return <BIMView />
            case 'globalreg':
                return <GlobalRegView />
            case 'users':
                return <UsersView />
            case 'configurators':
                return <ConfiguratorView />
            case 'notifications':
                return <NotificationView />
            case 'translations':
                return <TranslationsView />
            case 'profile':
                return <ProfileView />
            case 'videofeed':
                return <VideoFeedView />
            default:
                return null
        }
    }

    render() {
        const { open, arcGISOpen, dataOpen, anchorEl, selectedIndex, viewName } = this.state;

        return (
            <ThemeProvider theme={mdTheme}>
                <Box sx={{ display: 'flex' }}>
                    <CssBaseline enableColorScheme />
                    <AppBar position="fixed" open={open}>
                        <Toolbar
                            sx={{
                                pr: '24px', // keep right padding when drawer closed
                            }}
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                onClick={this.toggleDrawer}
                                sx={{
                                    marginRight: '36px',
                                    ...(open && { display: 'none' }),
                                }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography
                                component="h1"
                                variant="h6"
                                color="inherit"
                                noWrap
                                sx={{ flexGrow: 1 }}
                            >
                                <a href="/">
                                    <Box
                                        component="img"
                                        sx={{
                                            height: 36,
                                        }}
                                        alt="Abraxas"
                                        src="/images/AbraxasLogoOnBlue.png"
                                    />
                                </a>
                            </Typography>
                            <IconButton
                                size="large"
                                aria-label="show 17 new notifications"
                                color="inherit"
                            >
                                <Badge badgeContent={17} color="error">
                                    <NotificationsIcon />
                                </Badge>
                            </IconButton>
                            <IconButton color="inherit">
                                <Badge badgeContent={4} color="secondary">
                                    <NotificationsIcon />
                                </Badge>
                            </IconButton>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={this.handleMenu}
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={this.handleClose}
                            >
                                {/* <MenuItem onClick={this.handleClose}>Profile</MenuItem> */}
                                <MenuItem onClick={() => { window.location.href = "/dashboard/profile"; }}>Profile</MenuItem>
                                <MenuItem onClick={() => signout(() => { window.location.href = "/"; })}>Sign Out</MenuItem>
                            </Menu>
                        </Toolbar>
                    </AppBar>
                    <Drawer variant="permanent" open={open}>
                        <Toolbar
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                px: [1],
                            }}
                        >
                            <Box
                                component="img"
                                sx={{
                                    height: 36,
                                }}
                                alt="Abraxas"
                                src="/images/AbraxasIconOnWhite.png"
                            />
                            <ListItemText
                                sx={{ my: 0 }}
                                primary="Abraxas Tools"
                                primaryTypographyProps={{
                                    fontSize: 20,
                                    fontWeight: 'medium',
                                    letterSpacing: 0,
                                }}
                            />
                            <IconButton onClick={this.toggleDrawer}>
                                <ChevronLeftIcon />
                            </IconButton>
                        </Toolbar>
                        <Divider />
                        <List>
                            <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                                <List component="nav" aria-label="main mailbox folders">
                                    <ListItemButton
                                        selected={selectedIndex === '0'}
                                        onClick={(event) => this.handleListItemClick(event, '0', "main")}
                                    >
                                        <ListItemIcon>
                                            <DashboardIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Dashboard" />
                                    </ListItemButton>

                                    <ListItemButton onClick={this.handleListArcGISClick}>
                                        <ListItemIcon>
                                            <TravelExploreRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="arcGIS APIs" />
                                        {arcGISOpen ? <ExpandLess /> : <ExpandMore />}
                                    </ListItemButton>
                                    <Collapse in={arcGISOpen} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                selected={selectedIndex === '1'}
                                                onClick={(event) => this.handleListItemClick(event, '1', "arcGIS")}
                                            >
                                                <ListItemIcon>
                                                    <AddLocationAltIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="arcGIS" />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>

                                    <Collapse in={arcGISOpen} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                selected={selectedIndex === '16'}
                                                onClick={(event) => this.handleListItemClick(event, '16', "arcGIS3d")}
                                            >
                                                <ListItemIcon>
                                                    <ThreeDRotationIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="arcGIS 3d" />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>

                                    <Collapse in={arcGISOpen} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                selected={selectedIndex === '17'}
                                                onClick={(event) => this.handleListItemClick(event, '17', "arcGISIOT")}
                                            >
                                                <ListItemIcon>
                                                    <OnDeviceTrainingIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="arcGIS IOT" />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>

                                    <Collapse in={arcGISOpen} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                selected={selectedIndex === '16b'}
                                                onClick={(event) => this.handleListItemClick(event, '16', "arcGISEnviro")}
                                            >
                                                <ListItemIcon>
                                                    <ThermostatIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="arcGIS Enviro" />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>

                                    {/* <ListItemButton
                                        selected={selectedIndex === '1'}
                                        onClick={(event) => this.handleListItemClick(event, '1', "arcGIS")}
                                    >
                                        <ListItemIcon>
                                            <DashboardIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="arcGIS" />
                                    </ListItemButton> */}

                                    {/* <ListItemButton
                                        selected={selectedIndex === '16'}
                                        onClick={(event) => this.handleListItemClick(event, '16', "arcGIS3d")}
                                    >
                                        <ListItemIcon>
                                            <DashboardIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="arcGIS 3d" />
                                    </ListItemButton> */}

                                    {/* <ListItemButton
                                        selected={selectedIndex === '17'}
                                        onClick={(event) => this.handleListItemClick(event, '17', "arcGISIOT")}
                                    >
                                        <ListItemIcon>
                                            <DashboardIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="arcGIS IOT" />
                                    </ListItemButton> */}


                                    <ListItemButton
                                        selected={selectedIndex === '2'}
                                        onClick={(event) => this.handleListItemClick(event, '2', "projects")}
                                    >
                                        <ListItemIcon>
                                            <ContentCopyRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Projects" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '3'}
                                        onClick={(event) => this.handleListItemClick(event, '3', "designs")}
                                    >
                                        <ListItemIcon>
                                            <ViewInArRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Design" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '4'}
                                        onClick={(event) => this.handleListItemClick(event, '4', "construction")}
                                    >
                                        <ListItemIcon>
                                            <EngineeringRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Construction" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '5'}
                                        onClick={(event) => this.handleListItemClick(event, '5', "operations")}
                                    >
                                        <ListItemIcon>
                                            <CorporateFareRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Operations" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '6'}
                                        onClick={(event) => this.handleListItemClick(event, '6', "analytics")}
                                    >
                                        <ListItemIcon>
                                            <AddchartRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Analytics" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '7'}
                                        onClick={(event) => this.handleListItemClick(event, '7', "visualization")}
                                    >
                                        <ListItemIcon>
                                            <CameraRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Visualization" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '8'}
                                        onClick={(event) => this.handleListItemClick(event, '8', "management")}
                                    >
                                        <ListItemIcon>
                                            <ManageAccountsRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Management" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '9'}
                                        onClick={(event) => this.handleListItemClick(event, '9', "assetstore")}
                                    >
                                        <ListItemIcon>
                                            <StoreRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Asset Store" />
                                    </ListItemButton>

                                    {/* <ListItemButton
                                        selected={selectedIndex === '8'}
                                        onClick={(event) => this.handleListItemClick(event, '8', "videofeed")}
                                    >
                                        <ListItemIcon>
                                            <ManageAccountsRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="videofeed" />
                                    </ListItemButton> */}


                                </List>
                                <Divider />
                                <List component="nav" aria-label="secondary mailbox folder">
                                    <ListItemButton onClick={this.handleDataClick}>
                                        <ListItemIcon>
                                            <AccountTreeRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Data" />
                                        {dataOpen ? <ExpandLess /> : <ExpandMore />}
                                    </ListItemButton>
                                    <Collapse in={dataOpen} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                selected={selectedIndex === '10'}
                                                onClick={(event) => this.handleListItemClick(event, '10', "bim")}
                                            >
                                                <ListItemIcon>
                                                    <FormatLineSpacingRoundedIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="BIM data" />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>

                                    <Collapse in={dataOpen} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                selected={selectedIndex === '11'}
                                                onClick={(event) => this.handleListItemClick(event, '11', "globalreg")}
                                            >
                                                <ListItemIcon>
                                                    <TravelExploreRoundedIcon />
                                                </ListItemIcon>
                                                <ListItemText primary="Global Registry" />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>

                                    <ListItemButton
                                        selected={selectedIndex === '12'}
                                        onClick={(event) => this.handleListItemClick(event, '12', "users")}
                                    >
                                        <ListItemIcon>
                                            <SettingsAccessibilityRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Users" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '13'}
                                        onClick={(event) => this.handleListItemClick(event, '13', "configurators")}
                                    >
                                        <ListItemIcon>
                                            <DisplaySettingsRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Configurators" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '14'}
                                        onClick={(event) => this.handleListItemClick(event, '14', "notifications")}
                                    >
                                        <ListItemIcon>
                                            <NotificationsActiveRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Notifications" />
                                    </ListItemButton>

                                    <ListItemButton
                                        selected={selectedIndex === '15'}
                                        onClick={(event) => this.handleListItemClick(event, '15', "translations")}
                                    >
                                        <ListItemIcon>
                                            <MediationRoundedIcon />
                                        </ListItemIcon>
                                        <ListItemText primary="Translations" />
                                    </ListItemButton>

                                </List>
                            </Box>
                        </List>
                    </Drawer>
                    <Box
                        component="main"
                        sx={{
                            backgroundColor: 'text.disabled',
                            flexGrow: 1,
                            height: '100vh',
                            overflow: 'auto',
                        }}
                    >
                        <Toolbar />
                        {/* <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}> */}
                        <Container sx={{ mt: 2, mb: 2, lg: 2 }} maxWidth="xl">
                            <Grid item xs={12} md={12} lg={12}>
                                <Paper
                                    sx={{
                                        p: 2,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: 50,
                                    }}
                                >
                                    <Grid container spacing={3}>
                                        <Grid item xs={6} md={6} lg={6}>
                                            <Breadcrumbs aria-label="breadcrumb">
                                                <Link
                                                    underline="hover"
                                                    sx={{ display: 'flex', alignItems: 'center' }}
                                                    color="inherit"
                                                    href="/dashboard/main"
                                                >
                                                    <DashboardIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                                    Dashboard
                                                </Link>
                                                {this.secondaryLink(viewName)}
                                            </Breadcrumbs>
                                        </Grid>
                                        <Grid item xs={6} md={6} lg={6}>
                                            {this.getDescriptionForHelp(viewName)}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Container>
                        {this.getTheProperView(viewName)}
                    </Box>
                </Box>
                <Copyright sx={{ pt: 4 }} />
            </ThemeProvider>
        )
    }
}

export default DashboardContent;